import ResizeObserver from 'resize-observer-polyfill'

import { throttle } from 'lodash-es'
import { Plugin } from '../entities/plugin'
import { EVENT_NAME } from '../types'

export const ResizeObserverExtension = Plugin.create<
  unknown,
  {
    observer?: ResizeObserver
  }
>({
  name: 'resize-observer',
  addStorage() {
    return {
      observer: undefined,
    }
  },
  onPluginInit(graph) {
    const observer = new ResizeObserver(
      throttle(() => {
        graph.changeSize()
        graph.emit(EVENT_NAME.resize)
      }, 300)
    )

    observer.observe(graph.renderer.container)

    this.setStorage({
      observer,
    })
  },
  onDestroy() {
    this.storage.observer?.disconnect()
  },
})
